<template>
     <div class="container" style="margin-top:20px;font-size:13px !important">
        <div class="callDetaisl_table">
            <ul id="tabTable" role="tablist" class="nav nav-tabs">
                <li class="nav-item" @click="iscallLog(true)"><a id="Call-Immediately-tab" data-toggle="tab"  role="tab" aria-controls="Call-Immediately" aria-selected="false" class="nav-link" v-bind:class="{ active: isActive, 'show': hasError }">Schedule Calls    </a></li>
                <li class="nav-item" @click="iscallLog(false)"><a id="call-Schedule-tab" data-toggle="tab" role="tab" aria-controls="call-Schedule" aria-selected="true" class="nav-link" v-bind:class="{ active: !isActive, 'show': !hasError }">Call Logs</a></li>
            </ul>

            <div id="tabTable" class="tab-content">
                <div id="Call-Immediately" role="tabpanel" aria-labelledby="Call-Immediately-tab" class="tab-pane fade"  v-bind:class="{ active: isActive, 'show': hasError }">
                <div class="call_duration"><p style="font-size: 17px;">Call Duration Pending – <span style="color: #F75511">{{ duration }} mins</span></p></div>
                <table class="table table-hover roa-table">
                    <thead>
                    <tr>
                        <th>Date</th> 
                        <th>Time</th> 
                        <th>Topic/Message </th> 
                        <th>Scheduled by</th> 
                        <!-- <th>More</th> 
                        <th style="text-align: center;"></th> -->
                    </tr>
                    </thead> 
                    <tbody>
                    <tr v-for="data in list" :key="data.id">
                        <td>{{data.sc_date | FormatDate('DD-MM-YYYY')}}</td>
                        <td>{{data.sc_time }}</td>
                        <td>{{data.sc_text }}</td>
                        <td>{{ data.account_manager.first_name }}</td>
                        <!-- <td><a>Edit Schedule</a></td>
                        <td><a>Delete</a></td> -->
                    </tr>
                    </tbody>
                </table>
                </div>
                <div id="call-Schedule" role="tabpanel" aria-labelledby="call-Schedule-tab" class="tab-pane fade "  v-bind:class="{ active: !isActive, 'show': !hasError }">
                <div class="call_duration"><p style="font-size: 17px;">Call Duration Pending – <span style="color: #F75511">{{ duration }} mins</span></p></div>
                <table class="table table-hover roa-table">
                    <thead>
                    <tr>
                        <th>Date</th> 
                        <th>Time</th> 
                        <th>Duration</th> 
                        <!-- <th>Topic/Message </th>  -->
                    </tr>
                    </thead> 
                    <tbody >
                    <tr v-for="call_data in call_log" :key="call_data.id">
                        <td v-if="call_data.response_text">{{call_data.response_text.StartTime | FormatDate('DD-MM-YYYY')}}</td>
                        <td v-else></td>
                        <td v-if="call_data.response_text">{{call_data.response_text.StartTime | FormatDate('hh:mm a')}}</td>
                        <td v-else></td>
                        <td v-if="call_data.response_text">{{call_data.response_text.Duration}}</td>
                        <td v-else></td>
                        <!-- <td>Lorem Ipsum</td> -->
                    </tr>
                    </tbody>
                </table>
                </div>
            </div>
        </div> 
    </div>
</template>
<script>
import callDetails from '../../services/call_details'
export default {
    name:'call-list-index',
    props:['type'],
    data(){
        return{
            list:{},
            duration:60,
            isActive: true,
            hasError: true,
            scData:{
                session_user:123
            },
            call_log:{},
            file_path:process.env.VUE_APP_URL,
            pusherKey:process.env.VUE_APP_PUSHER_KEY
        }
    },
    component:{
    },
    methods: {
        iscallLog:function(data){
          if(data){
            this.isActive = true;
            this.hasError = true;
          }else{
            this.isActive = false;
            this.hasError = false;
          }
        },
        listOfScData(){
            callDetails.scList(this.scData)
                            .then((response) =>{
                  if(response.data.status == "success"){
                     this.list = response.data.sclist;  
                     let overall_dur = 0;
                     this.call_log = response.data.call_s;
                    for(var i=0; i<this.call_log.length; i++){
                        if(this.call_log[i].response_text){
                            overall_dur = overall_dur+this.call_log[i].response_text.Duration
                        }
                    }
                    this.duration = this.duration - overall_dur;
                  }
                                
            })
        }
    },
    mounted(){
        this.$root.$on('sc_complete', () => {
            this.listOfScData();
            this.iscallLog(true);
        })
        this.listOfScData();    
    },
    created(){
           
    },

}
</script>
<style scoped>
@import '../../../assets/css/calling.css';
</style>